import { useEffect, useState } from 'react';
import { useGetEmployeePlantWorkShopManagersQuery } from '@Store/api/userApiSlice';

import { Option } from '@Components/types/options';
import { Flex, Typography } from 'antd';
import { MSelect } from '@Components/Base';

import styles from './fields-styles.module.css';

interface PlantWorkshopManagerFieldsProps {
  setValues: React.Dispatch<
    React.SetStateAction<{
      plantWorkshopManager: string;
    }>
  >;
}

const PlantWorkshopManagerFields: React.FC<PlantWorkshopManagerFieldsProps> = ({
  setValues,
}) => {
  const { data } = useGetEmployeePlantWorkShopManagersQuery();
  const [userOptions, setUserOptions] = useState<Array<Option>>([]);

  useEffect(() => {
    if (data) {
      const transformedUsers = data.map((user) => ({
        label: `${user.empName} | ${user.empNumber}`,
        value: String(user.userId),
      }));

      setUserOptions(transformedUsers);
    }
  }, [data]);

  return (
    <div className={styles.container}>
      <Flex vertical gap={16}>
        <div>
          <Typography.Text>
            Please choose the respective Plant Work shop Manager:
          </Typography.Text>
          <MSelect
            className={styles.purchaseOfficerSelect}
            options={userOptions}
            onChange={(value) => {
              setValues((prev) => {
                return { ...prev, plantWorkshopManager: value };
              });
            }}
            placeholder="Choose Plant Workshop Manager"
          />
        </div>
      </Flex>
    </div>
  );
};

export default PlantWorkshopManagerFields;
